import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { PROJECTS_FILES_HEADERS } from 'components/app/projects/_mediator/projects.params';
import { setTableSort } from 'components/app/projects/_mediator/projects.slice';

import { Select } from 'components/UI/select/select';
import styles from '../_selector-files.module.scss';

export const SelectorFilesSortSelect = () => {
  const filesTableSort = useAppSelector((state) => state.projects.filesTableSort);
  const dispatch = useAppDispatch();

  return (
    <div className={styles.Sort}>
      <Select
        colored
        placeholder="Sort by"
        options={PROJECTS_FILES_HEADERS.map((e, i) => ({ label: e, value: i }))}
        value={filesTableSort.column}
        className={styles.Sort__SortSelect}
        onChange={(e) =>
          dispatch(
            setTableSort({
              key: 'filesTableSort',
              value: {
                ...filesTableSort,
                column: +e.target.value,
              },
            })
          )
        }
      />
      <div
        className={styles.Sort__SortIcon}
        onClick={() =>
          dispatch(
            setTableSort({
              key: 'filesTableSort',
              value: { ...filesTableSort, order: filesTableSort.order === 'ASC' ? 'DESC' : 'ASC' },
            })
          )
        }
      >
        {filesTableSort.order === 'ASC' ? <p>&#8593;</p> : <p>&#8595;</p>}
      </div>
    </div>
  );
};
